module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "no-image-placeholder.af908b75.png";